
// defenses
export const GET_DEFENSES = "/defenses";
export const ADD_NEW_DEFENSE = "/defenses";
export const UPDATE_DEFENSE = "/defenses";
export const DELETE_DEFENSE = "/defenses";


